<template>
    <div>
        <div id="sidenav" class="sidenav" :class="{'nav-open' : $store.state.sideNav  }">
            <img style="height:80px; width:auto;" src="/img/Admin-logo.svg"  alt="">
            <div class="menu">
                <ul class="pl-0">
                    
                    <li class="mb-2" @click="setActiveIndex(1); $router.replace('/').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 1" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 1}" class="mb-0">Dashboard</p>
                    </li>

                    <li class="mb-2" @click="setActiveIndex(2); $router.replace('/doctors').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 2" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 2}" class="mb-0">Doctors</p>
                    </li>

                    <li class="mb-2" @click="setActiveIndex(3); $router.push('/patients').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 3" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 3}" class="mb-0">Patients</p>
                    </li>

                    <li class="mb-2" @click="setActiveIndex(4); $router.push('/notifications').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 4" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 4}" class="mb-0">Notifications</p>
                    </li>

                    <!-- <li class="mb-2" @click="setActiveIndex(5); $router.push('/calls').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 5" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 5}" class="mb-0">Calls</p>
                    </li> -->
                    <li class="mb-2" @click="setActiveIndex(6); $router.push('/reports/list').then().catch(err => {})">
                    <div v-if="activeIndex == 6" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 6}" class="mb-0">Reports</p>
                    </li>
                    <!-- <li class="mb-2" @click="setActiveIndex(4); $router.push('/incidents').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 4" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 4}" class="mb-0">Incidents/Requests</p>
                    </li> -->
                    <li class="mb-2" @click="setActiveIndex(5); $router.push('/insurances').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 5" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 5}" class="mb-0">Insurance Companies</p>
                    </li>
                   <!--  <li class="mb-2" @click="setActiveIndex(6); $router.push('/healthcare').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 6" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 6}" class="mb-0">Healthcare Facilities</p>
                    </li>
                    <li class="mb-2" @click="setActiveIndex(7); $router.push('/ambulance').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 7" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 7}" class="mb-0">Ambulance Companies</p>
                    </li>
                    <li class="mb-2" @click="swetActiveIndex(8); $router.push('/invoices').then(()=>{}).catch(err=>{})">
                        <div v-if="activeIndex == 8" class="activeBar"></div>
                        <p :class="{'activeSide' : activeIndex == 8}" class="mb-0">Receipts/Invoices</p>
                    </li> -->

                    <li @click="logout">
                        <p>logout</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed:{
        activeIndex(){
            return this.$store.state.activeIndex
        }
    },
    methods:{
        setActiveIndex(index){
            this.$store.dispatch('setActiveIndex',index)
        },
        logout(){
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push('/login')
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    .sidenav{
        height: 100%;
        width: 200px;
        background-color: rgb(255,255,255);
        display: flex;
        flex-direction: column

        
    }

    .menu{
        margin-top:100px;
    }

    p{
        padding-left: 15px;
    }

    p.activeSide{
        color:rgb(0, 170, 221);
    }

    li{
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 45px;
    }

    img{
      align-self: center;
      padding-top: 15px;
    }

    .activeBar{
        background-color:rgb(0,170,221);
        height:45px;
        width:5px; 
        position:absolute;
    }
</style>